import { jsPDF } from 'jspdf';
import { loadLogos, renderStandardHeader, renderStandardFooter, normalizeBranch, COLORS_PDF } from './pdfCommon';

export const generateInterconsultaPDF = async (ic, patient, owner, branchData, vetName) => {
  const branch = normalizeBranch(branchData);
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const logos = await loadLogos();
  const date = new Date().toLocaleDateString('es-CL');
  const numero = ic.id || '—';
  renderStandardHeader(doc, branch, logos, { title: 'INDICACIONES', number: numero, date });

  const pw = doc.internal.pageSize.getWidth();
  const margin = 16;
  const cw = pw - margin * 2;
  let y = 35;

  // Datos del paciente y tutor
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...COLORS_PDF.primary);
  doc.text('Paciente', margin, y);
  y += 5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...COLORS_PDF.text);
  doc.text(`${patient?.name || '—'}  ·  ${patient?.species || '—'}  ·  ${patient?.breed || ''}`, margin, y);
  y += 8;

  const tutor = [owner?.name, owner?.celular].filter(Boolean).join('  ·  ');
  if (tutor) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS_PDF.primary);
    doc.text('Tutor', margin, y);
    y += 5;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS_PDF.text);
    doc.text(tutor, margin, y);
    y += 8;
  }

  if (vetName) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS_PDF.primary);
    doc.text('Médico veterinario', margin, y);
    y += 5;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS_PDF.text);
    doc.text(vetName, margin, y);
    y += 10;
  }

  // Especialidades (solo si hay)
  const selected = ic.specialtyNames || [];
  if (selected.length) {
    y = renderSection(doc, 'Derivación a especialidad', margin, y, cw);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS_PDF.text);
    selected.forEach((s, i) => {
      doc.text(`[x] ${s}`, margin + 5, y + 5 + i * 6);
    });
    y += selected.length * 6 + 8;
  }

  // Indicaciones
  y = renderSection(doc, 'Indicaciones y notas', margin, y, cw);
  const notas = ic.notas || 'Sin indicaciones';
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...COLORS_PDF.text);
  const notasLines = doc.splitTextToSize(notas, cw - 10);
  doc.text(notasLines, margin + 5, y + 5);
  y += notasLines.length * 5 + 8;

  // Solicitud de exámenes en hoja separada (solo si hay)
  const examenes = (ic.examenes || '').trim();
  if (examenes) {
    doc.addPage();
    renderStandardHeader(doc, branch, logos, { title: 'SOLIC. EXÁMENES', number: numero, date });
    y = 35;
    y = renderSection(doc, 'Solicitud de exámenes', margin, y, cw);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS_PDF.text);
    const examLines = doc.splitTextToSize(examenes, cw - 10);
    doc.text(examLines, margin + 5, y + 5);
  }

  // Firma médico veterinario en primera página
  if (vetName) {
    doc.setPage(1);
    const pageH = doc.internal.pageSize.getHeight();
    const firmaY = pageH - 60;
    doc.setDrawColor(...COLORS_PDF.muted);
    doc.setLineWidth(0.3);
    doc.line(margin, firmaY, margin + 70, firmaY);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS_PDF.primary);
    doc.text(`Médico veterinario: ${vetName}`, margin, firmaY + 6);
  }

  renderStandardFooter(doc, branch);
  return doc;
};

function renderSection(doc, title, x, y, cw) {
  doc.setFillColor(...COLORS_PDF.light);
  doc.rect(x, y, cw, 8, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...COLORS_PDF.primary);
  doc.text(title, x + 3, y + 5.5);
  return y + 12;
}
